import { render } from "./ProductionOrderList.vue?vue&type=template&id=6cc0d4f1"
import script from "./ProductionOrderList.vue?vue&type=script&lang=js"
export * from "./ProductionOrderList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__